<template>
  <div class="user-cms">
    <Navbar/>
    <router-view :key="new Date().getTime()"/>
  </div>
</template>

<script>
import Navbar from '@/components/layout/Navbar.vue'
export default {
  name: 'UserCms',
  components: { Navbar }
}
</script>

<style lang="scss">
.user-cms{
  background-color: $background-color;
  min-height: 100vh;
}
</style>
